export {
  default,
  quantityCell
} from './QuantityDisplay'
